import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrModule, ToastrService } from 'ngx-toastr'
//import { ToastrManager } from 'ng6-toastr-notifications';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

    apiServiceURL: string = environment.apiEndPoint;
    //apiServiceURL: string = "https://localhost:7029/api/2.1.0/";
    HubsURL: any = environment.HubsURL;

    userMenus: any = [];
    IWantToMenu: any = [];
    SideBarMenu: any[] = [];
    Menu: any = [];
    Module: any = {};

    public getSubMenuItems(module: string, menuCode: string) {
        this.Menu = [];
        for (var i = 0; i < this.userMenus.length; i++) {
            if (this.userMenus[i].menuModule.moduleCode.toLowerCase() == module.toLowerCase()) {
                if (this.userMenus[i].menuCode.toLowerCase() == menuCode.toLowerCase())
                    this.userMenus[i].isActiveMenu = true;
                else
                    this.userMenus[i].isActiveMenu = false;
                this.Menu.push(this.userMenus[i]);
            }
        }
        if (this.Menu.length > 0) {
            this.Module = this.Menu[0].menuModule;
        }
    }

    setActiveModule(moduleCode: any) {
        for (var i = 0; i < this.SideBarMenu.length; i++) {
            if (this.SideBarMenu[i].code.toLowerCase() === moduleCode.toLowerCase()) {
                this.SideBarMenu[i].active = true;
                if (this.SideBarMenu[i].showTopAds)
                    this.showTopAds = "block";
                else
                    this.showTopAds = "none";
            }
            else
                this.SideBarMenu[i].active = false;
        }
    }

   



    constructor(private http: HttpClient, public toastr: ToastrService) {


    }

    public showTopAds: string = "none";

    getUserModuleItems(): any {
        return this._menuObj;
    }

    getUserModulesAndMenus(userId: string, emailAddress: string): any {

        return this.http.get(this.apiServiceURL + 'Account/getUserPortalModules?emailAddress=' + emailAddress + '&userId=' + userId);
    }

    _menuObj: any = [];
    _subMenuObj: any = [];

    ShowMessage(type: any, message: any, title: any) {
        
        if (type === 'info')
            this.toastr.info(message, title, {
                positionClass: 'toast-bottom-right'
            });
        else if (type === 'warning')
            this.toastr.warning(message, title, {
                positionClass: 'toast-bottom-right'
            });
        else if (type === 'error')
            this.toastr.error(message, title, {
                positionClass: 'toast-bottom-right'
            });
        else if (type === 'success')
            this.toastr.success(message, title, {
                positionClass: 'toast-bottom-right'
            });
    }

    public ValidatePassword(password: string): any {
        if (password == "") {
            return { "valid": false, "message": "password is mandatory" };
        }
        else {
            var passReg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            if (passReg.test(password)) {
                return { "valid": true, "message": "" };
            }
            else {
                return { "valid": false, "message": "Password must be at least 8 characters long, at least one uppercase letter, one lowercase letter, one number and one special character" };
            }
        }

    }

    public ValidateEmail(email: string): any {
        if (email == "") {
            return { "valid": false, "message": "email address is mandatory" };
        }
        else {
            var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (emailReg.test(email)) {
                return { "valid": true, "message": "" };
            }
            else {
                return { "valid": false, "message": "Email Address is not valid" };
            }
        }

    }


    public ValidateURL(string: string): any {
        let url;

        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }


    countries: any[] = [
        { value: "AE", name: "United Arab Emirates", code: "+971", "selected":"" },
        { value: "SA", name: "Saudi Arabia", code: "+966", "selected": "" },
        { value: "AF", name: "Afghanistan", code: "+93", "selected": "" },
        { value: "AL", name: "Albania", code: "+355", "selected": "" },
        { value: "DZ", name: "Algeria", code: "+213", "selected": "" },
        { value: "AS", name: "American Samoa", code: "+1-684", "selected": "" },
        { value: "AD", name: "Andorra", code: "+376", "selected": "" },
        { value: "AO", name: "Angola", code: "+244", "selected": "" },
        { value: "AI", name: "Anguilla", code: "+1-264", "selected": "" },
        { value: "AG", name: "Antigua and Barbuda", code: "+1-268", "selected": "" },
        { value: "AR", name: "Argentina", code: "+54", "selected": "" },
        { value: "AM", name: "Armenia", code: "+374", "selected": "" },
        { value: "AW", name: "Aruba", code: "+297", "selected": "" },
        { value: "AU", name: "Australia", code: "+61", "selected": "" },
        { value: "AT", name: "Austria", code: "+43", "selected": "" },
        { value: "AZ", name: "Azerbaijan", code: "+994", "selected": "" },
        { value: "BS", name: "Bahamas", code: "+1-242", "selected": "" },
        { value: "BH", name: "Bahrain", code: "+973", "selected": "" },
        { value: "BD", name: "Bangladesh", code: "+880", "selected": "" },
        { value: "BB", name: "Barbados", code: "+1-246", "selected": "" },
        { value: "BY", name: "Belarus", code: "+375", "selected": "" },
        { value: "BE", name: "Belgium", code: "+32", "selected": "" },
        { value: "BZ", name: "Belize", code: "+501", "selected": "" },
        { value: "BJ", name: "Benin", code: "+229", "selected": "" },
        { value: "BM", name: "Bermuda", code: "+1-441", "selected": "" },
        { value: "BT", name: "Bhutan", code: "+975", "selected": "" },
        { value: "BO", name: "Bolivia", code: "+591", "selected": "" },
        { value: "BA", name: "Bosnia and Herzegovina", code: "+387", "selected": "" },
        { value: "BW", name: "Botswana", code: "+267", "selected": "" },
        { value: "BR", name: "Brazil", code: "+55", "selected": "" },
        { value: "IO", name: "British Indian Ocean Territory", code: "+246", "selected": "" },
        { value: "BN", name: "Brunei Darussalam", code: "+673", "selected": "" },
        { value: "BG", name: "Bulgaria", code: "+359", "selected": "" },
        { value: "BF", name: "Burkina Faso", code: "+226", "selected": "" },
        { value: "BI", name: "Burundi", code: "+257", "selected": "" },
        { value: "KH", name: "Cambodia", code: "+855", "selected": "" },
        { value: "CM", name: "Cameroon", code: "+237", "selected": "" },
        { value: "CA", name: "Canada", code: "+1", "selected": "" },
        { value: "CV", name: "Cape Verde", code: "+238", "selected": "" },
        { value: "KY", name: "Cayman Islands", code: "+1-345", "selected": "" },
        { value: "CF", name: "Central African Republic", code: "+236", "selected": "" },
        { value: "TD", name: "Chad", code: "+235", "selected": "" },
        { value: "CL", name: "Chile", code: "+56", "selected": "" },
        { value: "CN", name: "China", code: "+86", "selected": "" },
        { value: "CO", name: "Colombia", code: "+57", "selected": "" },
        { value: "KM", name: "Comoros", code: "+269", "selected": "" },
        { value: "CG", name: "Congo", code: "+", "selected": "" },
        { value: "CD", name: "Congo, the Democratic Republic of the", code: "+", "selected": "" },
        { value: "CK", name: "Cook Islands", code: "+682", "selected": "" },
        { value: "CR", name: "Costa Rica", code: "+506", "selected": "" },
        { value: "CI", name: "C" + "&ocirc;" + "te d'Ivoire", code: "+", "selected": "" },
        { value: "HR", name: "Croatia", code: "+385", "selected": "" },
        { value: "CU", name: "Cuba", code: "+53", "selected": "" },
        { value: "CW", name: "Cura" + "&ccedil;" + "ao", code: "+", "selected": "" },
        { value: "CY", name: "Cyprus", code: "+357", "selected": "" },
        { value: "CZ", name: "Czech Republic", code: "+420", "selected": "" },
        { value: "DK", name: "Denmark", code: "+45", "selected": "" },
        { value: "DJ", name: "Djibouti", code: "+253", "selected": "" },
        { value: "DM", name: "Dominica", code: "+1-767", "selected": "" },
        { value: "DO", name: "Dominican Republic", code: "+", "selected": "" },
        { value: "EC", name: "Ecuador", code: "+593", "selected": "" },
        { value: "EG", name: "Egypt", code: "+20", "selected": "" },
        { value: "SV", name: "El Salvador", code: "+503", "selected": "" },
        { value: "GQ", name: "Equatorial Guinea", code: "+240", "selected": "" },
        { value: "ER", name: "Eritrea", code: "+291", "selected": "" },
        { value: "EE", name: "Estonia", code: "+372", "selected": "" },
        { value: "ET", name: "Ethiopia", code: "+251", "selected": "" },
        { value: "FK", name: "Falkland Islands (Malvinas)", code: "+500", "selected": "" },
        { value: "FO", name: "Faroe Islands", code: "+298", "selected": "" },
        { value: "FJ", name: "Fiji", code: "+679", "selected": "" },
        { value: "FI", name: "Finland", code: "+358", "selected": "" },
        { value: "FR", name: "France", code: "+33", "selected": "" },
        { value: "GF", name: "French Guiana", code: "+", "selected": "" },
        { value: "PF", name: "French Polynesia", code: "+689", "selected": "" },
        { value: "TF", name: "French Southern Territories", code: "+", "selected": "" },
        { value: "GA", name: "Gabon", code: "+241", "selected": "" },
        { value: "GM", name: "Gambia", code: "+220", "selected": "" },
        { value: "GE", name: "Georgia", code: "+995", "selected": "" },
        { value: "DE", name: "Germany", code: "+49", "selected": "" },
        { value: "GH", name: "Ghana", code: "+233", "selected": "" },
        { value: "GI", name: "Gibraltar", code: "+350", "selected": "" },
        { value: "GR", name: "Greece", code: "+30", "selected": "" },
        { value: "GD", name: "Grenada", code: "+", "selected": "" },
        { value: "GP", name: "Guadeloupe", code: "+", "selected": "" },
        { value: "GU", name: "Guam", code: "+1-671", "selected": "" },
        { value: "GT", name: "Guatemala", code: "+502", "selected": "" },
        { value: "GG", name: "Guernsey", code: "+", "selected": "" },
        { value: "GN", name: "Guinea", code: "+224", "selected": "" },
        { value: "GW", name: "Guinea-Bissau", code: "+245", "selected": "" },
        { value: "GY", name: "Guyana", code: "+592", "selected": "" },
        { value: "HT", name: "Haiti", code: "+509", "selected": "" },
        { value: "HM", name: "Heard Island and McDonald Islands", code: "+", "selected": "" },
        { value: "VA", name: "Holy See (Vatican City State)", code: "+", "selected": "" },
        { value: "HN", name: "Honduras", code: "+504", "selected": "" },
        { value: "HK", name: "Hong Kong", code: "+852", "selected": "" },
        { value: "HU", name: "Hungary", code: "+36", "selected": "" },
        { value: "IS", name: "Iceland", code: "+354", "selected": "" },
        { value: "IN", name: "India", code: "+91", "selected": "" },
        { value: "ID", name: "Indonesia", code: "+62", "selected": "" },
        { value: "IR", name: "Iran, Islamic Republic of", code: "+98", "selected": "" },
        { value: "IQ", name: "Iraq", code: "+964", "selected": "" },
        { value: "IE", name: "Ireland", code: "+353", "selected": "" },
        { value: "IM", name: "Isle of Man", code: "+", "selected": "" },
        { value: "IL", name: "Israel", code: "+972", "selected": "" },
        { value: "IT", name: "Italy", code: "+39", "selected": "" },
        { value: "JM", name: "Jamaica", code: "+", "selected": "" },
        { value: "JP", name: "Japan", code: "+81", "selected": "" },
        { value: "JE", name: "Jersey", code: "+", "selected": "" },
        { value: "JO", name: "Jordan", code: "+962", "selected": "" },
        { value: "KZ", name: "Kazakhstan", code: "+7", "selected": "" },
        { value: "KE", name: "Kenya", code: "+254", "selected": "" },
        { value: "KI", name: "Kiribati", code: "+686", "selected": "" },
        { value: "KP", name: "Korea, Democratic People's Republic of", code: "+", "selected": "" },
        { value: "KR", name: "Korea, Republic of", code: "+", "selected": "" },
        { value: "KW", name: "Kuwait", code: "+965", "selected": "" },
        { value: "KG", name: "Kyrgyzstan", code: "+996", "selected": "" },
        { value: "LA", name: "Lao People's Democratic Republic", code: "+", "selected": "" },
        { value: "LV", name: "Latvia", code: "+371", "selected": "" },
        { value: "LB", name: "Lebanon", code: "+961", "selected": "" },
        { value: "LS", name: "Lesotho", code: "+266", "selected": "" },
        { value: "LR", name: "Liberia", code: "+231", "selected": "" },
        { value: "LY", name: "Libya", code: "+218", "selected": "" },
        { value: "LI", name: "Liechtenstein", code: "+423", "selected": "" },
        { value: "LT", name: "Lithuania", code: "+370", "selected": "" },
        { value: "LU", name: "Luxembourg", code: "+352", "selected": "" },
        { value: "MO", name: "Macao", code: "+853", "selected": "" },
        { value: "MK", name: "Macedonia, the former Yugoslav Republic of", code: "+389", "selected": "" },
        { value: "MG", name: "Madagascar", code: "+261", "selected": "" },
        { value: "MW", name: "Malawi", code: "+265", "selected": "" },
        { value: "MY", name: "Malaysia", code: "+60", "selected": "" },
        { value: "MV", name: "Maldives", code: "+960", "selected": "" },
        { value: "ML", name: "Mali", code: "+223", "selected": "" },
        { value: "MT", name: "Malta", code: "+356", "selected": "" },
        { value: "MH", name: "Marshall Islands", code: "+692", "selected": "" },
        { value: "MQ", name: "Martinique", code: "+", "selected": "" },
        { value: "MR", name: "Mauritania", code: "+222", "selected": "" },
        { value: "MU", name: "Mauritius", code: "+230", "selected": "" },
        { value: "YT", name: "Mayotte", code: "+262", "selected": "" },
        { value: "MX", name: "Mexico", code: "+52", "selected": "" },
        { value: "FM", name: "Micronesia, Federated States of", code: "+691", "selected": "" },
        { value: "MD", name: "Moldova, Republic of", code: "+373", "selected": "" },
        { value: "MC", name: "Monaco", code: "+377", "selected": "" },
        { value: "MN", name: "Mongolia", code: "+976", "selected": "" },
        { value: "ME", name: "Montenegro", code: "+382", "selected": "" },
        { value: "MS", name: "Montserrat", code: "+", "selected": "" },
        { value: "MA", name: "Morocco", code: "+212", "selected": "" },
        { value: "MZ", name: "Mozambique", code: "+258", "selected": "" },
        { value: "MM", name: "Myanmar", code: "+95", "selected": "" },
        { value: "NA", name: "Namibia", code: "+264", "selected": "" },
        { value: "NR", name: "Nauru", code: "+674", "selected": "" },
        { value: "NP", name: "Nepal", code: "+977", "selected": "" },
        { value: "NL", name: "Netherlands", code: "+31", "selected": "" },
        { value: "NC", name: "New Caledonia", code: "+687", "selected": "" },
        { value: "NZ", name: "New Zealand", code: "+64", "selected": "" },
        { value: "NI", name: "Nicaragua", code: "+505", "selected": "" },
        { value: "NE", name: "Niger", code: "+227", "selected": "" },
        { value: "NG", name: "Nigeria", code: "+234", "selected": "" },
        { value: "NU", name: "Niue", code: "+683", "selected": "" },
        { value: "NF", name: "Norfolk Island", code: "+", "selected": "" },
        { value: "MP", name: "Northern Mariana Islands", code: "+", "selected": "" },
        { value: "NO", name: "Norway", code: "+47", "selected": "" },
        { value: "OM", name: "Oman", code: "+968", "selected": "" },
        { value: "PK", name: "Pakistan", code: "+92", "selected": "" },
        { value: "PW", name: "Palau", code: "+680", "selected": "" },
        { value: "PS", name: "Palestinian Territory, Occupied", code: "+970", "selected": "" },
        { value: "PA", name: "Panama", code: "+507", "selected": "" },
        { value: "PG", name: "Papua New Guinea", code: "+675", "selected": "" },
        { value: "PY", name: "Paraguay", code: "+595", "selected": "" },
        { value: "PE", name: "Peru", code: "+", "selected": "" },
        { value: "PH", name: "Philippines", code: "+63", "selected": "" },
        { value: "PN", name: "Pitcairn", code: "+64", "selected": "" },
        { value: "PL", name: "Poland", code: "+48", "selected": "" },
        { value: "PT", name: "Portugal", code: "+351", "selected": "" },
        { value: "PR", name: "Puerto Rico", code: "+", "selected": "" },
        { value: "QA", name: "Qatar", code: "+974", "selected": "" },
        { value: "RE", name: "R" + "&eacute;" + "union", code: "+", "selected": "" },
        { value: "RO", name: "Romania", code: "+40", "selected": "" },
        { value: "RU", name: "Russian Federation", code: "+7", "selected": "" },
        { value: "RW", name: "Rwanda", code: "+250", "selected": "" },
        { value: "SH", name: "Saint Helena, Ascension and Tristan da Cunha", code: "+", "selected": "" },
        { value: "KN", name: "Saint Kitts and Nevis", code: "+", "selected": "" },
        { value: "LC", name: "Saint Lucia", code: "+", "selected": "" },
        { value: "MF", name: "Saint Martin (French part)", code: "+", "selected": "" },
        { value: "PM", name: "Saint Pierre and Miquelon", code: "+", "selected": "" },
        { value: "VC", name: "Saint Vincent and the Grenadines", code: "+", "selected": "" },
        { value: "WS", name: "Samoa", code: "+685", "selected": "" },
        { value: "SM", name: "San Marino", code: "+378", "selected": "" },
        { value: "ST", name: "Sao Tome and Principe", code: "+239", "selected": "" },

        { value: "SN", name: "Senegal", code: "+221", "selected": "" },
        { value: "RS", name: "Serbia", code: "+381", "selected": "" },
        { value: "SC", name: "Seychelles", code: "+248", "selected": "" },
        { value: "SL", name: "Sierra Leone", code: "+232", "selected": "" },
        { value: "SG", name: "Singapore", code: "+65", "selected": "" },
        { value: "SX", name: "Sint Maarten (Dutch part)", code: "+", "selected": "" },
        { value: "SK", name: "Slovakia", code: "+421", "selected": "" },
        { value: "SI", name: "Slovenia", code: "+386", "selected": "" },
        { value: "SB", name: "Solomon Islands", code: "+677", "selected": "" },
        { value: "SO", name: "Somalia", code: "+252", "selected": "" },
        { value: "ZA", name: "South Africa", code: "+27", "selected": "" },
        { value: "GS", name: "South Georgia and the South Sandwich Islands", code: "+", "selected": "" },
        { value: "SS", name: "South Sudan", code: "+211", "selected": "" },
        { value: "ES", name: "Spain", code: "+34", "selected": "" },
        { value: "LK", name: "Sri Lanka", code: "+94", "selected": "" },
        { value: "SD", name: "Sudan", code: "+249", "selected": "" },
        { value: "SR", name: "Suriname", code: "+597", "selected": "" },
        { value: "SZ", name: "Swaziland", code: "+268", "selected": "" },
        { value: "SE", name: "Sweden", code: "+46", "selected": "" },
        { value: "CH", name: "Switzerland", code: "+41", "selected": "" },
        { value: "SY", name: "Syrian Arab Republic", code: "+963", "selected": "" },
        { value: "TW", name: "Taiwan, Province of China", code: "+886", "selected": "" },
        { value: "TJ", name: "Tajikistan", code: "+992", "selected": "" },
        { value: "TZ", name: "Tanzania, United Republic of", code: "+255", "selected": "" },
        { value: "TH", name: "Thailand", code: "+66", "selected": "" },
        { value: "TL", name: "Timor-Leste", code: "+", "selected": "" },
        { value: "TG", name: "Togo", code: "+228", "selected": "" },
        { value: "TK", name: "Tokelau", code: "+690", "selected": "" },
        { value: "TO", name: "Tonga", code: "+676", "selected": "" },
        { value: "TT", name: "Trinidad and Tobago", code: "+", "selected": "" },
        { value: "TN", name: "Tunisia", code: "+216", "selected": "" },
        { value: "TR", name: "Turkey", code: "+90", "selected": "" },
        { value: "TM", name: "Turkmenistan", code: "+993", "selected": "" },
        { value: "TC", name: "Turks and Caicos Islands", code: "+", "selected": "" },
        { value: "TV", name: "Tuvalu", code: "+688", "selected": "" },
        { value: "UG", name: "Uganda", code: "+256", "selected": "" },
        { value: "UA", name: "Ukraine", code: "+380", "selected": "" },
        { value: "GB", name: "United Kingdom", code: "+44", "selected": "" },
        { value: "US", name: "United States", code: "+1", "selected": "" },
        { value: "UM", name: "United States Minor Outlying Islands", code3: "+1", "selected": "" },
        { value: "UY", name: "Uruguay", code: "+598", "selected": "" },
        { value: "UZ", name: "Uzbekistan", code: "+998", "selected": "" },
        { value: "VU", name: "Vanuatu", code: "+678", "selected": "" },
        { value: "VE", name: "Venezuela, Bolivarian Republic of", code: "+58", "selected": "" },
        { value: "VN", name: "Viet Nam", code: "+84", "selected": "" },
        { value: "VG", name: "Virgin Islands, British", code: "+", "selected": "" },
        { value: "VI", name: "Virgin Islands, U.S.", code: "+", "selected": "" },
        { value: "WF", name: "Wallis and Futuna", code: "+", "selected": "" },
        { value: "EH", name: "Western Sahara", code: "+212", "selected": "" },
        { value: "YE", name: "Yemen", code: "+967", "selected": "" },
        { value: "ZM", name: "Zambia", code: "+260", "selected": "" },
        { value: "ZW", name: "Zimbabwe", code: "+263", "selected": "" },
    ];
    nationalities: any[] = [
        { value: "AE", name: "United Arab Emirates", code: "+971", "selected": "" },
        { value: "SA", name: "Saudi Arabia", code: "+966", "selected": "" },
        { value: "AF", name: "Afghanistan", code: "+93", "selected": "" },
        { value: "AL", name: "Albania", code: "+355", "selected": "" },
        { value: "DZ", name: "Algeria", code: "+213", "selected": "" },
        { value: "AS", name: "American Samoa", code: "+1-684", "selected": "" },
        { value: "AD", name: "Andorra", code: "+376", "selected": "" },
        { value: "AO", name: "Angola", code: "+244", "selected": "" },
        { value: "AI", name: "Anguilla", code: "+1-264", "selected": "" },
        { value: "AG", name: "Antigua and Barbuda", code: "+1-268", "selected": "" },
        { value: "AR", name: "Argentina", code: "+54", "selected": "" },
        { value: "AM", name: "Armenia", code: "+374", "selected": "" },
        { value: "AW", name: "Aruba", code: "+297", "selected": "" },
        { value: "AU", name: "Australia", code: "+61", "selected": "" },
        { value: "AT", name: "Austria", code: "+43", "selected": "" },
        { value: "AZ", name: "Azerbaijan", code: "+994", "selected": "" },
        { value: "BS", name: "Bahamas", code: "+1-242", "selected": "" },
        { value: "BH", name: "Bahrain", code: "+973", "selected": "" },
        { value: "BD", name: "Bangladesh", code: "+880", "selected": "" },
        { value: "BB", name: "Barbados", code: "+1-246", "selected": "" },
        { value: "BY", name: "Belarus", code: "+375", "selected": "" },
        { value: "BE", name: "Belgium", code: "+32", "selected": "" },
        { value: "BZ", name: "Belize", code: "+501", "selected": "" },
        { value: "BJ", name: "Benin", code: "+229", "selected": "" },
        { value: "BM", name: "Bermuda", code: "+1-441", "selected": "" },
        { value: "BT", name: "Bhutan", code: "+975", "selected": "" },
        { value: "BO", name: "Bolivia", code: "+591", "selected": "" },
        { value: "BA", name: "Bosnia and Herzegovina", code: "+387", "selected": "" },
        { value: "BW", name: "Botswana", code: "+267", "selected": "" },
        { value: "BR", name: "Brazil", code: "+55", "selected": "" },
        { value: "IO", name: "British Indian Ocean Territory", code: "+246", "selected": "" },
        { value: "BN", name: "Brunei Darussalam", code: "+673", "selected": "" },
        { value: "BG", name: "Bulgaria", code: "+359", "selected": "" },
        { value: "BF", name: "Burkina Faso", code: "+226", "selected": "" },
        { value: "BI", name: "Burundi", code: "+257", "selected": "" },
        { value: "KH", name: "Cambodia", code: "+855", "selected": "" },
        { value: "CM", name: "Cameroon", code: "+237", "selected": "" },
        { value: "CA", name: "Canada", code: "+1", "selected": "" },
        { value: "CV", name: "Cape Verde", code: "+238", "selected": "" },
        { value: "KY", name: "Cayman Islands", code: "+1-345", "selected": "" },
        { value: "CF", name: "Central African Republic", code: "+236", "selected": "" },
        { value: "TD", name: "Chad", code: "+235", "selected": "" },
        { value: "CL", name: "Chile", code: "+56", "selected": "" },
        { value: "CN", name: "China", code: "+86", "selected": "" },
        { value: "CO", name: "Colombia", code: "+57", "selected": "" },
        { value: "KM", name: "Comoros", code: "+269", "selected": "" },
        { value: "CG", name: "Congo", code: "+", "selected": "" },
        { value: "CD", name: "Congo, the Democratic Republic of the", code: "+", "selected": "" },
        { value: "CK", name: "Cook Islands", code: "+682", "selected": "" },
        { value: "CR", name: "Costa Rica", code: "+506", "selected": "" },
        { value: "CI", name: "C" + "&ocirc;" + "te d'Ivoire", code: "+", "selected": "" },
        { value: "HR", name: "Croatia", code: "+385", "selected": "" },
        { value: "CU", name: "Cuba", code: "+53", "selected": "" },
        { value: "CW", name: "Cura" + "&ccedil;" + "ao", code: "+", "selected": "" },
        { value: "CY", name: "Cyprus", code: "+357", "selected": "" },
        { value: "CZ", name: "Czech Republic", code: "+420", "selected": "" },
        { value: "DK", name: "Denmark", code: "+45", "selected": "" },
        { value: "DJ", name: "Djibouti", code: "+253", "selected": "" },
        { value: "DM", name: "Dominica", code: "+1-767", "selected": "" },
        { value: "DO", name: "Dominican Republic", code: "+", "selected": "" },
        { value: "EC", name: "Ecuador", code: "+593", "selected": "" },
        { value: "EG", name: "Egypt", code: "+20", "selected": "" },
        { value: "SV", name: "El Salvador", code: "+503", "selected": "" },
        { value: "GQ", name: "Equatorial Guinea", code: "+240", "selected": "" },
        { value: "ER", name: "Eritrea", code: "+291", "selected": "" },
        { value: "EE", name: "Estonia", code: "+372", "selected": "" },
        { value: "ET", name: "Ethiopia", code: "+251", "selected": "" },
        { value: "FK", name: "Falkland Islands (Malvinas)", code: "+500", "selected": "" },
        { value: "FO", name: "Faroe Islands", code: "+298", "selected": "" },
        { value: "FJ", name: "Fiji", code: "+679", "selected": "" },
        { value: "FI", name: "Finland", code: "+358", "selected": "" },
        { value: "FR", name: "France", code: "+33", "selected": "" },
        { value: "GF", name: "French Guiana", code: "+", "selected": "" },
        { value: "PF", name: "French Polynesia", code: "+689", "selected": "" },
        { value: "TF", name: "French Southern Territories", code: "+", "selected": "" },
        { value: "GA", name: "Gabon", code: "+241", "selected": "" },
        { value: "GM", name: "Gambia", code: "+220", "selected": "" },
        { value: "GE", name: "Georgia", code: "+995", "selected": "" },
        { value: "DE", name: "Germany", code: "+49", "selected": "" },
        { value: "GH", name: "Ghana", code: "+233", "selected": "" },
        { value: "GI", name: "Gibraltar", code: "+350", "selected": "" },
        { value: "GR", name: "Greece", code: "+30", "selected": "" },
        { value: "GD", name: "Grenada", code: "+", "selected": "" },
        { value: "GP", name: "Guadeloupe", code: "+", "selected": "" },
        { value: "GU", name: "Guam", code: "+1-671", "selected": "" },
        { value: "GT", name: "Guatemala", code: "+502", "selected": "" },
        { value: "GG", name: "Guernsey", code: "+", "selected": "" },
        { value: "GN", name: "Guinea", code: "+224", "selected": "" },
        { value: "GW", name: "Guinea-Bissau", code: "+245", "selected": "" },
        { value: "GY", name: "Guyana", code: "+592", "selected": "" },
        { value: "HT", name: "Haiti", code: "+509", "selected": "" },
        { value: "HM", name: "Heard Island and McDonald Islands", code: "+", "selected": "" },
        { value: "VA", name: "Holy See (Vatican City State)", code: "+", "selected": "" },
        { value: "HN", name: "Honduras", code: "+504", "selected": "" },
        { value: "HK", name: "Hong Kong", code: "+852", "selected": "" },
        { value: "HU", name: "Hungary", code: "+36", "selected": "" },
        { value: "IS", name: "Iceland", code: "+354", "selected": "" },
        { value: "IN", name: "India", code: "+91", "selected": "" },
        { value: "ID", name: "Indonesia", code: "+62", "selected": "" },
        { value: "IR", name: "Iran, Islamic Republic of", code: "+98", "selected": "" },
        { value: "IQ", name: "Iraq", code: "+964", "selected": "" },
        { value: "IE", name: "Ireland", code: "+353", "selected": "" },
        { value: "IM", name: "Isle of Man", code: "+", "selected": "" },
        { value: "IL", name: "Israel", code: "+972", "selected": "" },
        { value: "IT", name: "Italy", code: "+39", "selected": "" },
        { value: "JM", name: "Jamaica", code: "+", "selected": "" },
        { value: "JP", name: "Japan", code: "+81", "selected": "" },
        { value: "JE", name: "Jersey", code: "+", "selected": "" },
        { value: "JO", name: "Jordan", code: "+962", "selected": "" },
        { value: "KZ", name: "Kazakhstan", code: "+7", "selected": "" },
        { value: "KE", name: "Kenya", code: "+254", "selected": "" },
        { value: "KI", name: "Kiribati", code: "+686", "selected": "" },
        { value: "KP", name: "Korea, Democratic People's Republic of", code: "+", "selected": "" },
        { value: "KR", name: "Korea, Republic of", code: "+", "selected": "" },
        { value: "KW", name: "Kuwait", code: "+965", "selected": "" },
        { value: "KG", name: "Kyrgyzstan", code: "+996", "selected": "" },
        { value: "LA", name: "Lao People's Democratic Republic", code: "+", "selected": "" },
        { value: "LV", name: "Latvia", code: "+371", "selected": "" },
        { value: "LB", name: "Lebanon", code: "+961", "selected": "" },
        { value: "LS", name: "Lesotho", code: "+266", "selected": "" },
        { value: "LR", name: "Liberia", code: "+231", "selected": "" },
        { value: "LY", name: "Libya", code: "+218", "selected": "" },
        { value: "LI", name: "Liechtenstein", code: "+423", "selected": "" },
        { value: "LT", name: "Lithuania", code: "+370", "selected": "" },
        { value: "LU", name: "Luxembourg", code: "+352", "selected": "" },
        { value: "MO", name: "Macao", code: "+853", "selected": "" },
        { value: "MK", name: "Macedonia, the former Yugoslav Republic of", code: "+389", "selected": "" },
        { value: "MG", name: "Madagascar", code: "+261", "selected": "" },
        { value: "MW", name: "Malawi", code: "+265", "selected": "" },
        { value: "MY", name: "Malaysia", code: "+60", "selected": "" },
        { value: "MV", name: "Maldives", code: "+960", "selected": "" },
        { value: "ML", name: "Mali", code: "+223", "selected": "" },
        { value: "MT", name: "Malta", code: "+356", "selected": "" },
        { value: "MH", name: "Marshall Islands", code: "+692", "selected": "" },
        { value: "MQ", name: "Martinique", code: "+", "selected": "" },
        { value: "MR", name: "Mauritania", code: "+222", "selected": "" },
        { value: "MU", name: "Mauritius", code: "+230", "selected": "" },
        { value: "YT", name: "Mayotte", code: "+262", "selected": "" },
        { value: "MX", name: "Mexico", code: "+52", "selected": "" },
        { value: "FM", name: "Micronesia, Federated States of", code: "+691", "selected": "" },
        { value: "MD", name: "Moldova, Republic of", code: "+373", "selected": "" },
        { value: "MC", name: "Monaco", code: "+377", "selected": "" },
        { value: "MN", name: "Mongolia", code: "+976", "selected": "" },
        { value: "ME", name: "Montenegro", code: "+382", "selected": "" },
        { value: "MS", name: "Montserrat", code: "+", "selected": "" },
        { value: "MA", name: "Morocco", code: "+212", "selected": "" },
        { value: "MZ", name: "Mozambique", code: "+258", "selected": "" },
        { value: "MM", name: "Myanmar", code: "+95", "selected": "" },
        { value: "NA", name: "Namibia", code: "+264", "selected": "" },
        { value: "NR", name: "Nauru", code: "+674", "selected": "" },
        { value: "NP", name: "Nepal", code: "+977", "selected": "" },
        { value: "NL", name: "Netherlands", code: "+31", "selected": "" },
        { value: "NC", name: "New Caledonia", code: "+687", "selected": "" },
        { value: "NZ", name: "New Zealand", code: "+64", "selected": "" },
        { value: "NI", name: "Nicaragua", code: "+505", "selected": "" },
        { value: "NE", name: "Niger", code: "+227", "selected": "" },
        { value: "NG", name: "Nigeria", code: "+234", "selected": "" },
        { value: "NU", name: "Niue", code: "+683", "selected": "" },
        { value: "NF", name: "Norfolk Island", code: "+", "selected": "" },
        { value: "MP", name: "Northern Mariana Islands", code: "+", "selected": "" },
        { value: "NO", name: "Norway", code: "+47", "selected": "" },
        { value: "OM", name: "Oman", code: "+968", "selected": "" },
        { value: "PK", name: "Pakistan", code: "+92", "selected": "" },
        { value: "PW", name: "Palau", code: "+680", "selected": "" },
        { value: "PS", name: "Palestinian Territory, Occupied", code: "+970", "selected": "" },
        { value: "PA", name: "Panama", code: "+507", "selected": "" },
        { value: "PG", name: "Papua New Guinea", code: "+675", "selected": "" },
        { value: "PY", name: "Paraguay", code: "+595", "selected": "" },
        { value: "PE", name: "Peru", code: "+", "selected": "" },
        { value: "PH", name: "Philippines", code: "+63", "selected": "" },
        { value: "PN", name: "Pitcairn", code: "+64", "selected": "" },
        { value: "PL", name: "Poland", code: "+48", "selected": "" },
        { value: "PT", name: "Portugal", code: "+351", "selected": "" },
        { value: "PR", name: "Puerto Rico", code: "+", "selected": "" },
        { value: "QA", name: "Qatar", code: "+974", "selected": "" },
        { value: "RE", name: "R" + "&eacute;" + "union", code: "+", "selected": "" },
        { value: "RO", name: "Romania", code: "+40", "selected": "" },
        { value: "RU", name: "Russian Federation", code: "+7", "selected": "" },
        { value: "RW", name: "Rwanda", code: "+250", "selected": "" },
        { value: "SH", name: "Saint Helena, Ascension and Tristan da Cunha", code: "+", "selected": "" },
        { value: "KN", name: "Saint Kitts and Nevis", code: "+", "selected": "" },
        { value: "LC", name: "Saint Lucia", code: "+", "selected": "" },
        { value: "MF", name: "Saint Martin (French part)", code: "+", "selected": "" },
        { value: "PM", name: "Saint Pierre and Miquelon", code: "+", "selected": "" },
        { value: "VC", name: "Saint Vincent and the Grenadines", code: "+", "selected": "" },
        { value: "WS", name: "Samoa", code: "+685", "selected": "" },
        { value: "SM", name: "San Marino", code: "+378", "selected": "" },
        { value: "ST", name: "Sao Tome and Principe", code: "+239", "selected": "" },

        { value: "SN", name: "Senegal", code: "+221", "selected": "" },
        { value: "RS", name: "Serbia", code: "+381", "selected": "" },
        { value: "SC", name: "Seychelles", code: "+248", "selected": "" },
        { value: "SL", name: "Sierra Leone", code: "+232", "selected": "" },
        { value: "SG", name: "Singapore", code: "+65", "selected": "" },
        { value: "SX", name: "Sint Maarten (Dutch part)", code: "+", "selected": "" },
        { value: "SK", name: "Slovakia", code: "+421", "selected": "" },
        { value: "SI", name: "Slovenia", code: "+386", "selected": "" },
        { value: "SB", name: "Solomon Islands", code: "+677", "selected": "" },
        { value: "SO", name: "Somalia", code: "+252", "selected": "" },
        { value: "ZA", name: "South Africa", code: "+27", "selected": "" },
        { value: "GS", name: "South Georgia and the South Sandwich Islands", code: "+", "selected": "" },
        { value: "SS", name: "South Sudan", code: "+211", "selected": "" },
        { value: "ES", name: "Spain", code: "+34", "selected": "" },
        { value: "LK", name: "Sri Lanka", code: "+94", "selected": "" },
        { value: "SD", name: "Sudan", code: "+249", "selected": "" },
        { value: "SR", name: "Suriname", code: "+597", "selected": "" },
        { value: "SZ", name: "Swaziland", code: "+268", "selected": "" },
        { value: "SE", name: "Sweden", code: "+46", "selected": "" },
        { value: "CH", name: "Switzerland", code: "+41", "selected": "" },
        { value: "SY", name: "Syrian Arab Republic", code: "+963", "selected": "" },
        { value: "TW", name: "Taiwan, Province of China", code: "+886", "selected": "" },
        { value: "TJ", name: "Tajikistan", code: "+992", "selected": "" },
        { value: "TZ", name: "Tanzania, United Republic of", code: "+255", "selected": "" },
        { value: "TH", name: "Thailand", code: "+66", "selected": "" },
        { value: "TL", name: "Timor-Leste", code: "+", "selected": "" },
        { value: "TG", name: "Togo", code: "+228", "selected": "" },
        { value: "TK", name: "Tokelau", code: "+690", "selected": "" },
        { value: "TO", name: "Tonga", code: "+676", "selected": "" },
        { value: "TT", name: "Trinidad and Tobago", code: "+", "selected": "" },
        { value: "TN", name: "Tunisia", code: "+216", "selected": "" },
        { value: "TR", name: "Turkey", code: "+90", "selected": "" },
        { value: "TM", name: "Turkmenistan", code: "+993", "selected": "" },
        { value: "TC", name: "Turks and Caicos Islands", code: "+", "selected": "" },
        { value: "TV", name: "Tuvalu", code: "+688", "selected": "" },
        { value: "UG", name: "Uganda", code: "+256", "selected": "" },
        { value: "UA", name: "Ukraine", code: "+380", "selected": "" },
        { value: "GB", name: "United Kingdom", code: "+44", "selected": "" },
        { value: "US", name: "United States", code: "+1", "selected": "" },
        { value: "UM", name: "United States Minor Outlying Islands", code3: "+1", "selected": "" },
        { value: "UY", name: "Uruguay", code: "+598", "selected": "" },
        { value: "UZ", name: "Uzbekistan", code: "+998", "selected": "" },
        { value: "VU", name: "Vanuatu", code: "+678", "selected": "" },
        { value: "VE", name: "Venezuela, Bolivarian Republic of", code: "+58", "selected": "" },
        { value: "VN", name: "Viet Nam", code: "+84", "selected": "" },
        { value: "VG", name: "Virgin Islands, British", code: "+", "selected": "" },
        { value: "VI", name: "Virgin Islands, U.S.", code: "+", "selected": "" },
        { value: "WF", name: "Wallis and Futuna", code: "+", "selected": "" },
        { value: "EH", name: "Western Sahara", code: "+212", "selected": "" },
        { value: "YE", name: "Yemen", code: "+967", "selected": "" },
        { value: "ZM", name: "Zambia", code: "+260", "selected": "" },
        { value: "ZW", name: "Zimbabwe", code: "+263", "selected": "" },
    ];

}